import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { createWebocInfo, updateWebocInfo } from "./actions/customsActions";

export interface CustomsState {
  loader: true | false;
}

const initialState: CustomsState = {
  loader: false,
};

export const customsSlice = createSlice({
  name: "customs",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  extraReducers: (builder) => {
    // Post createWebocInfo methods
    builder.addCase(createWebocInfo.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(createWebocInfo.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(createWebocInfo.fulfilled, (state) => {
      state.loader = false;
    });
    // ./createWebocInfo methods

    // Post updateWebocInfo methods
    builder.addCase(updateWebocInfo.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateWebocInfo.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateWebocInfo.fulfilled, (state) => {
      state.loader = false;
    });
    // ./updateWebocInfo methods
  },
});

export const loader = (state: RootState) => state.insights.loader;
